import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { OrganisationInteractionService } from '../../../services';
import { IInteractionCategory } from '../../../interfaces/interactions/interaction-category';
import { compare } from 'fast-json-patch';

@Component({
  selector: 'app-interaction-category-admin',
  styleUrls: ['./interaction-category-admin.component.scss'],
  templateUrl: './interaction-category-admin.component.html',
})
export class InteractionCategoryAdminComponent implements OnInit {
  constructor(private interactionService: OrganisationInteractionService) {}

  categories: IInteractionCategory[];
  categoryName: string;

  ngOnInit() {
    this.loadCategories();
  }

  loadCategories() {
    this.interactionService.getInteractionCategories(false).then((res) => {
      this.categories = res;
    });
  }

  addCategory() {
    const dto = <IInteractionCategory>{
      name: this.categoryName,
    };

    this.interactionService.addInteractionCategory(dto).then((result) => {
      if (result) {
        this.loadCategories();
      }
    });
  }

  setCategoryActivation(category: IInteractionCategory) {
    this.interactionService.setCategoryActivation(category.id).then((res) => {
      this.loadCategories();
    });
  }

  onEditComplete(event: any) {
    const name = event.data.name;

    const patch = compare({ name: '' }, { name: event.data.name });

    this.interactionService.updateInteractionCategory(event.data.id, patch);
  }
}
